import {
  select,
} from 'redux-saga/effects';

const authState = state => state.auth;

export function obtenerValorPermiso({ permisos, clave, tipo }) {
  if (permisos && clave) {
    const tipoConfiguracion = tipo || 'permiso';
    const permiso = permisos[tipoConfiguracion][clave];
    if (permiso !== undefined) {
      if (permiso === 'S' || permiso === 's' || permiso === 'T' || permiso === 't') return true;
      if (permiso === 'N' || permiso === 'n' || permiso === 'F' || permiso === 'f') return false;
      return permisos[tipoConfiguracion];
    }
    console.log('No se ha encontrado una configuración del tipo (' + tipoConfiguracion + ') con la clave (' + clave + ')');
  }
  return undefined;
}

export function* valorPermiso(clave, tipo = 'permiso') {
  const auth = yield select(authState);
  if (auth) {
    const { permisos } = auth;
    if (permisos) {
      switch (tipo) {
        case 'permiso': {
          const { permiso } = permisos;
          if (permiso) {
            return permiso[clave];
          }
          return undefined;
        }
        case 'configuracion': {
          const { configuracion } = permisos;
          if (configuracion) {
            return configuracion[clave];
          }
          return undefined;
        }
        default: {
          return undefined;
        }
      }
    }
  }
  return undefined;
}
const getPaisEntorno = (ambito) => {
  switch (ambito) {
    case 1:
      return 'ES';
    case 2:
      return 'PT';
    case 3:
      return 'AD';
    case 4:
      return 'CO';
    case 5:
      return 'SN';
    case 6:
      return 'MX';
    case 8:
      return 'CL';
    case 9:
      return 'BQ';
    default:
      return 'ES';
      break;
  }
};
